import React from 'react';

import Typography from 'components/typography/typography';

import Button from 'components/button/button';

import Icon from 'components/icon/icon';

import { DISTANCE_OPTIONS } from 'constants/freelancer-ads-all-constants';

import { createLocale } from 'locales';

import { useFreelancerPeriodJobs } from 'state/context/freelancer/FreelancerPeriodJobs';

const localize = createLocale('freelancerAvailableJobsLocales');

export const FilterHeader: React.FC = () => {
  return (
    <div className="flex w-full flex-row items-center  justify-start h-14 text-purple">
      <Icon icon="filter1" className="mx-2 " size={30} />
      <Typography as="h2" variant="page-subheading" className="ml-4">
        {localize('filter')}
      </Typography>
    </div>
  );
};

export const AvailableJobFilterForm: React.FC = () => {
  const {
    handleFilterEnabled,
    distance,
    minimumPay,
    setDistance,
    setMinimumPay,
    periodJobs,
  } = useFreelancerPeriodJobs();
  return (
    <div className="container w-full text-purple">
      <div className="container h-fit flex flex-col ml-4 md:ml-0 md:flex-row md:items-center  w-full pr-10 mt-5 mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-5 text-purple"
        >
          {localize('minimumHourlyRate')}
        </Typography>
        <div className="w-full md:w-10/12  md:ml-5 items-start justify-center">
          <input
            value={minimumPay}
            onChange={(event) => {
              let val = 0;
              val =
                event.target.value !== '' && Number(event.target.value) >= 0
                  ? Number(event.target.value)
                  : 0;
              setMinimumPay(val.toString());
            }}
            id="min-tarif"
            placeholder={localize('minimumHourlyRate')}
            type="number"
            className="col w-full h-9 border active:border-gray-800 bg-background rounded-md pl-5 pr-2 text-body-large border-slate300"
          />
        </div>
      </div>

      <div className="container h-fit flex flex-col ml-4 md:ml-0 md:flex-row md:items-center w-full pr-10 mx-auto mb-4">
        <Typography
          as="h2"
          variant="body-large-bold"
          className="col w-full md:w-2/12 text-start md:text-end mr-10 text-purple"
        >
          {localize('travelDistance')}
        </Typography>
        <div className="col w-full md:w-10/12 items-start justify-center">
          <select
            value={distance}
            onChange={(e) => {
              setDistance(e.target.value);
            }}
            id="distance"
            aria-label="distance"
            className="w-full h-9 border bg-background border-gray-800 rounded-md pl-5 pr-2 text-body-large border-slate300"
          >
            {DISTANCE_OPTIONS.map(([values, stringDisplay], index) => (
              <option
                value={values}
                id={index.toString()}
                key={values + Date.now()}
              >
                {stringDisplay}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="container flex flex-row justify-between md:justify-center w-full mx-auto mb-4">
        <div className="flex  w-full md:w-1/2 items-center justify-center">
          <Button
            disabled={periodJobs.isLoading}
            onClick={() => {
              handleFilterEnabled(true);
              periodJobs.refetch({ throwOnError: true });
            }}
            label={localize('applyFilters')}
            variant="primary"
            className="flex items-center bg-lightBlue justify-center px-10  hover:bg-darkBlue disabled:bg-danger hover:text-white text-center"
          />
        </div>
        <div className="flex flex-col w-full md:w-1/2 items-center justify-center">
          <Button
            label={localize('allServices')}
            variant="outlined"
            className="flex items-center text-body-medium justify-center px-10 content-center hover:bg-gray100 hover:text-white"
            labelClassName="text-body-medium"
            onClick={() => {
              handleFilterEnabled(false);
            }}
          />
        </div>
      </div>
    </div>
  );
};
